import React from 'react';
import {
    SideNavigation, 
  } from 'AWS-UI-Components-React';
export const CustomNavigation = () => (
  <div>
    <SideNavigation 
        header={{ text: 'Navigation panel', href: '#/' }}
        items={[
          { type: 'link', text: 'Home Page', href: './main'},
          { type: 'link', text: 'Audit Outfits Page', href: './review'},
          { type: 'link', text: 'Browse Audited Page', href: './browse'},
          { type: 'link', text: 'Dashboard', href: './dashboard'},
          { type: "divider" },
        ]}
        activeHref="#/"
    />
  </div>
);

{/* Main link */}


// WEBPACK FOOTER //
// ./src/components/customNavigation.jsx